import apisConfig from "../../constants/baseUrl";
import axios from "../utils/api";
import {
  ClientFormValues,
  JobEvaluationFormValues1,
  smtp_Props,
} from "../types/type";
import { getCookie } from "../utils/AccessCookies";
import { toast } from "react-toastify";
import moment from "moment";

interface SignInFormValues {
  email: string;
  password: string;
  isAdmin: boolean;
}

interface ChangePasswordProps {
  oldPassword: string;
  newPassword: string;
  modified_on: string;
}

export const Login_Email_Password = async (values: SignInFormValues) => {
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/login/`,
    {
      email: values?.email,
      password: values?.password,
      admin: values?.isAdmin,
    },
    { withCredentials: true }
  );
  return response.data;
};

export const getCardsData = async () => {
  const authData = getCookie("UserData");
  const response = await axios.get(
    `${apisConfig.APIS.api_dev}/dashboard/getCards`,
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const getClientCards = async (client_id: any) => {
  const authData = getCookie("UserData");
  try {
    const response = await axios.get(
      `${apisConfig.APIS.api_dev}/dashboard/clientDashboard/${client_id}`,
      {
        headers: {
          Authorization: `Bearer ${authData?.accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in Get Cards method", error);
  }
};

export const getNoteficationsapi = async (user: any, notif_Type: string) => {
  const { accessToken } = getCookie("UserData");
  try {
    const response = await axios.post(
      `${apisConfig.APIS.api_dev}/notifications`,
      { user, notif_Type },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in Get Cards method", error);
  }
};

export const changeNoteficationStatus = async (id: number, obj: any) => {
  const authData = getCookie("UserData");
  try {
    const response = await axios.put(
      `${apisConfig.APIS.api_dev}/notifications/${id}`,
      obj,
      {
        headers: {
          Authorization: `Bearer ${authData?.accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in Get Cards method", error);
  }
};

export const getRecentJobEvaluations = async () => {
  const authData = getCookie("UserData");
  try {
    const response = await axios.get(
      `${apisConfig.APIS.api_dev}/dashboard/getRecentJobEvaluations`,
      {
        headers: {
          Authorization: `Bearer ${authData?.accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in Get Cards method", error);
  }
};

export const getClientsRecentJobEvaluations = async (client_id: any) => {
  const authData = getCookie("UserData");
  try {
    const response = await axios.get(
      `${apisConfig.APIS.api_dev}/dashboard/getclientRecentJobEvaluations/${client_id}`,
      {
        headers: {
          Authorization: `Bearer ${authData?.accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in Get Cards method", error);
  }
};

export const getInactiveClient = async () => {
  const authData = getCookie("UserData");
  const response = await axios.get(
    `${apisConfig.APIS.api_dev}/dashboard/getInactiveClient`,
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response?.data || [];
};

export const changePassword = async (values: ChangePasswordProps) => {
  const authData = getCookie("UserData");

  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/changePassword`,
    {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
      modified_on: values?.modified_on,
    },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const UpdateProfile = async (formData: any, user_id: any) => {
  const authData = getCookie("UserData");
  const response = await axios.put(
    `${apisConfig.APIS.api_dev}/admin/${user_id}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const updateClientProfile = async (values: any) => {
  const authData = getCookie("UserData");
  const response = await axios.put(
    `${apisConfig.APIS.api_dev}/clients/${values?.client_id}`,
    {
      company_name: values?.comp_Name?.trim(),
      logo: values?.logo,
      contact_person: values?.poc?.trim(),
      email: values?.primary_email?.trim(),
      alternate_email: values?.secondary_email?.trim(),
      mobile: values?.primary_mobile?.trim()?.toString(),
      alternate_mobile: values?.secondary_mobile?.trim()?.toString(),
      password: values?.password?.trim(),
      date_of_expiry: values?.date_of_expiry,
      address: values?.address?.trim(),
      pincode: values?.pincode,
      modified_on: values?.modified_on,
    },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const getUserData = async () => {
  const authData = getCookie("UserData");
  const response = await axios.get(`${apisConfig.APIS.api_dev}/getUser/`, {
    headers: {
      Authorization: `Bearer ${authData?.accessToken}`,
    },
  });
  return response.data;
};

export const uploadFile = async (formData: FormData) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/upload/`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const deleteFile = async (filePath: string) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/upload/delete`,
    { fileName: filePath },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const updateProfile = async (jsonObj: any) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/upload/delete`,
    jsonObj,
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const DeleteUsers = async (user_id: number) => {
  const response = await axios.delete(
    `${apisConfig.APIS.api_dev}/user/delete/${user_id}`
  );
  return response.data;
};

export const downloadExcelapi = async (Evaluationids: any) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/job_evaluation/excelExport?directDownload=1`,
    { job_eval_id: Evaluationids },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
      responseType: "blob",
    }
  );
  return response;
};

export const downloadPdfapi = async (data: any) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/job_evaluation/downloadPdf?directDownload=1`,
    { job_eval: data },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
      responseType: "blob",
    }
  );
  return response;
};

export const downloadExcelClientsapi = async () => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/clients/excelExport?directDownload=1`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
      responseType: "blob",
    }
  );
  return response;
};

export const downloadPdfClientsapi = async () => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/clients/downloadPdf?directDownload=1`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
      responseType: "blob",
    }
  );
  return response;
};

export const sendEmailapi = async (obj: any) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/job_evaluation/sendEmail`,
    obj,
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const AddJobEvaluation = async (
  values: JobEvaluationFormValues1,
  token: string
) => {
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/job_evaluation/`,
    { ...values, duration_Modified_On: values.created_on },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const UpdateJobEvaluation = async (
  values: JobEvaluationFormValues1,
  oldData: JobEvaluationFormValues1,
  token: string,
  job_Evaluation_ID: number
) => {
  const response = await axios.put(
    `${apisConfig.APIS.api_dev}/job_evaluation/${job_Evaluation_ID}`,
    values,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const UpdateSMTP_Settings = async (
  values: smtp_Props,
  userId: number,
  token: string
) => {
  const response = await axios.put(
    `${apisConfig.APIS.api_dev}/admin/${userId}`,
    values,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const GetAllClients = async (token: string) => {
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/clients/getAllClients`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
export const GetAllEmp_Types = async (token: string) => {
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/employment_type/getAllEmpTypes`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
export const GetAllSpread_Points = async (token: string) => {
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/point_spread/getAllPoint_Spreads`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
export const GetAllSkillValuesData = async (token: string) => {
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/skill_value/getSkillValues`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
export const GetAllSkillValues = async (id: number, token: string) => {
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/skill_value/getBySkillID/${id}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const GetOneJobEvaluation = async (
  rowEditedId: number,
  token: string
) => {
  const response = await axios.get(
    `${apisConfig.APIS.api_dev}/job_evaluation/${rowEditedId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
export const GetOneJobEvaluationHistory = async (
  job_eval_history_id: number,
  token: string
) => {
  const response = await axios.get(
    `${apisConfig.APIS.api_dev}/job_evaluation_History/${job_eval_history_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const AddClient = async (values: ClientFormValues) => {
  const authData = getCookie("UserData");

  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/clients/`,
    {
      comp_Name: values?.comp_Name,
      poc: values?.poc,
      password: values?.password,
      primary_mobile: values?.primary_mobile,
      primary_email: values?.primary_email,
      secondary_mobile: values?.secondary_mobile,
      secondary_email: values?.secondary_email,
      total_job_evaluations: values?.total_job_evaluations,
      no_of_job_evaluations: values?.no_of_job_evaluations,
      utilized_job_evaluations: values?.utilized_job_evaluations,
      logo: values?.logo,
      date_of_expiry: values?.date_of_expiry,
      address: values?.address,
      pincode: String(values?.pincode).trim(),
      created_by: authData?.userId,
      status: values?.status,
      created_on: values?.created_on,
    },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const EditClient = async (values: ClientFormValues | any) => {
  console.log("EditClient544", values);
  const authData = getCookie("UserData");
  const response = await axios.put(
    `${apisConfig.APIS.api_dev}/clients/${values?.client_id}`,
    {
      company_name: values?.comp_Name,
      logo: values?.logo,
      contact_person: values?.poc,
      email: values?.primary_email,
      alternate_email: values?.secondary_email,
      mobile: values?.primary_mobile,
      alternate_mobile: values?.secondary_mobile,
      password: values?.password,
      no_of_job_evaluations: values?.no_job_evaluations,
      total_job_evaluations: values?.total_job_evaluations,
      date_of_expiry: values?.date_of_expiry,
      address: values?.address,
      pincode: values?.pincode,
      status: values?.status,
      modified_on:
        values?.modified_on || moment().format("YYYY-MM-DD HH:mm:ss"),
      modified_by: values?.modified_by,
    },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const UpdateJobEvaluationsCount = async (
  values: ClientFormValues | any
) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/clients/updateJobEvaluationsCount`,
    values,
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};
export const ActiveEceededClient = async (values: ClientFormValues | any) => {
  const authData = getCookie("UserData");
  const response = await axios.put(
    `${apisConfig.APIS.api_dev}/clients/exceededClients/${values?.client_id}`,
    {
      no_of_job_evaluations: values?.no_job_evaluations,
      total_job_evaluations: values?.total_job_evaluations,
      NoOfcredits: values?.credits,
      modified_by: values?.modified_by,
      modified_on: values?.modified_on,
      is_modified_Admin: values?.is_modified_Admin,
    },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const GetClient = async () => {
  try {
    const authData = getCookie("UserData");
    const response = await axios.post(
      `${apisConfig.APIS.api_dev}/clients/getAllClients`,
      {},
      {
        headers: {
          Authorization: `Bearer ${authData?.accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in Signup method", error);
  }
};

export const GetClientById = async (id: number) => {
  try {
    const authData = getCookie("UserData");
    const response = await axios.get(
      `${apisConfig.APIS.api_dev}/clients/getClientByID/${id}`,
      {
        headers: {
          Authorization: `Bearer ${authData?.accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in Signup method", error);
  }
};
export const getExceededClients = async () => {
  const authData = getCookie("UserData");
  const response = await axios.get(
    `${apisConfig.APIS.api_dev}/clients/exceededClients`,
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const GetJobEvaluation = async (
  userId: number | null,
  status: string,
  pageNo: number = 1,
  pageSize: number = 20
) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/job_evaluation/job_eval_all?pageNo=${pageNo}&pageSize=${pageSize}`,
    {
      userID: userId,
      statusFlag: "revised",
      status: status == "Active" ? 1 : status == "All" ? "" : 0,
    },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const DeleteJobEvaluation = async (jobEvalId: number) => {
  const authData = getCookie("UserData");
  const response = await axios.delete(
    `${apisConfig.APIS.api_dev}/job_evaluation/${jobEvalId}`,
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const GetDeletedJobEvaluation = async (userId: number | null = null) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/job_evaluation/getDeletedJobEvaluations`,
    {
      userID: userId,
    },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};
export const GetInactiveJobEvaluation = async (userId: number) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/job_evaluation/getInactiveJobEvaluations`,
    {
      userId: userId,
    },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};
export const GetNotificationsBySearch = async (
  e: string,
  client_id: string,
  isThisAdmin: number,
  notify_Type: boolean
) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/notifications/search`,
    {
      search_Key: e,
      client_id: client_id,
      isThisAdmin: isThisAdmin,
      notify_Type: notify_Type,
    },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};
export const GetJobEvaluationsHistory = async (jobEvalId: number | null) => {
  const authData = getCookie("UserData");
  const response = await axios.post(
    `${apisConfig.APIS.api_dev}/job_evaluation_History/job_eval_history_all`,
    { jobEvalId },
    {
      headers: {
        Authorization: `Bearer ${authData?.accessToken}`,
      },
    }
  );
  return response.data;
};

export const GetSkillValuePoints = async (
  id: number | null,
  selectedType: any[]
) => {
  try {
    const authData = getCookie("UserData");
    const response = await axios.post(
      `${apisConfig.APIS.api_dev}/job_evaluation/getSkillValuePoints`,
      { skill_Value_Id: id, skillTypes: selectedType },
      {
        headers: {
          Authorization: `Bearer ${authData?.accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in Signup method", error);
  }
};

export const SearchJobEvaluation = async (searchData: any) => {
  try {
    const { accessToken, expires_in, userData } = getCookie("UserData");

    const response = await axios.post(
      `${apisConfig.APIS.api_dev}/job_evaluation/search`,
      {
        searchData: searchData,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("API error:", error.response.data);
      return error.response.data;
    }
    console.error("Unexpected error:", error);
    throw new Error("Unexpected error occurred");
  }
};

export const FindClientsByExpiryDate = async (searchVal: any) => {
  try {
    const { accessToken } = getCookie("UserData");

    const response = await axios.post(
      `${apisConfig.APIS.api_dev}/clients/search`,
      searchVal,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("API error:", error.response.data);
      return error.response.data;
    }
    console.error("Unexpected error:", error);
    throw new Error("Unexpected error occurred");
  }
};

export const GetUserById = async (id: any, token: any) => {
  try {
    const response = await axios.get(`${apisConfig.APIS.api_dev}/admin/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in Get User By Id method", error);
  }
};
